<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    this.bodyScale()
    let self = this
    window.onload = window.onresize = function () {
      self.bodyScale()
    }
  },
  methods: {
    bodyScale () {
      var devicewidth = window.innerWidth
      var scale = devicewidth / 1920 // 分母——设计稿的尺寸
      document.body.style.zoom = scale
    }
  }
}
</script>

<style>

@font-face {
  font-family: SourceHanSansCN-Light;
  src: url('~@/static/font/SourceHanSansCN-Light.otf');
}
#app {
  font-family: SourceHanSansCN-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
  color: #303133;
  font-size: 16px;
  height: 100%;
}
</style>
